import * as React from 'react';
import { Provider } from 'react-redux';
import {
  i18nReducer,
  loadTranslations,
  setLocale,
  syncTranslationWithStore,
} from 'react-redux-i18n';
import { AnyAction } from 'redux';

import { SpreadsheetDetails } from './spreadsheet-details';
import { createStore } from '@common/utils/redux';
import { spreadsheetDetailsEN } from './translations/en';
import { spreadsheetDetailsES } from './translations/es';
import { spreadsheetDetailsJA } from './translations/ja';
import spreadsheetsReducers from '@modules/spreadsheets/reducers';
import { mountReactNode } from '@common/utils/react';
import { clearFormatData } from '@modules/spreadsheets/actions/spreadsheetFormat';

export const initSpreadsheetDetails = function (componentId: string, locale: string, individual: boolean, formatId: number, run: boolean,
                                                      folderId: number, pedigreeId: number) {
type SpreadsheetStore = ReturnType<typeof createStore>;
  try {
    let store: SpreadsheetStore;
    if (typeof window !== 'undefined' && (window as any).__SPREADSHEET_STORE__) {
      // Reuse existing store to preserve all state including filter data
      store = (window as any).__SPREADSHEET_STORE__ as SpreadsheetStore;
      const currentState = store.getState();
  
    } else {
      // Create new store with spreadsheet reducers (includes spreadsheetFormat reducer)
      const initialState = {};
      store = createStore(spreadsheetsReducers, initialState);
    }
  
    syncTranslationWithStore(store);
  
    const translation = {
      en: spreadsheetDetailsEN,
      ja: spreadsheetDetailsJA,
      es: spreadsheetDetailsES,
    };

    const spreadsheetProps = {
      spreadsheetId: formatId,
      isRunSpreadsheet: run,
      isIndividual: individual,
      initialFolderId: folderId,
      initialFamilyId: pedigreeId,
    }
  
    if (!translation[locale as keyof typeof translation]) {
      locale = 'en';
    }
  
    store.dispatch(loadTranslations(translation));
    store.dispatch(setLocale(locale));
    
    // Always expose store to window for debugging (same as main spreadsheet module)
    // This ensures the store reference is always available
    if (typeof window !== 'undefined') {
        (window as any).__SPREADSHEET_STORE__ = store;
        const currentState = store.getState();
        
        // Add a single global event listener for spreadsheet tab close events
        // This listener will handle all spreadsheet tab closures and clear Redux filters
        if (!(window as any).__SPREADSHEET_TAB_CLOSE_LISTENER_ADDED__) {
            const handleTabClose = (event: CustomEvent<{ spreadsheetId: number | null; spreadsheetType: string }>) => {
                const { spreadsheetId, spreadsheetType } = event.detail;
                // Allow ID 0 for unsaved spreadsheets
                if (spreadsheetId != null && spreadsheetId !== undefined && store) {
                    // Dispatch Redux action to clear all format data (including filters) for the closed spreadsheet
                    store.dispatch(clearFormatData(spreadsheetId, spreadsheetType) as AnyAction);
                }
            };
            
            window.addEventListener('spreadsheet:tabClosed', handleTabClose as EventListener);
            (window as any).__SPREADSHEET_TAB_CLOSE_LISTENER_ADDED__ = true;
        }
    }

    // Always expose store to window for debugging (same as main spreadsheet module)
    // This ensures the store reference is always available
    if (typeof window !== 'undefined') {
        (window as any).__SPREADSHEET_STORE__ = store;
        const currentState = store.getState();

        // Add a single global event listener for spreadsheet tab close events
        // This listener will handle all spreadsheet tab closures and clear Redux filters
        if (!(window as any).__SPREADSHEET_TAB_CLOSE_LISTENER_ADDED__) {
            const handleTabClose = (event: CustomEvent<{ spreadsheetId: number | null; spreadsheetType: string }>) => {
                const { spreadsheetId, spreadsheetType } = event.detail;
                // Allow ID 0 for unsaved spreadsheets
                if (spreadsheetId != null && spreadsheetId !== undefined && store) {
                    // Dispatch Redux action to clear all format data (including filters) for the closed spreadsheet
                    store.dispatch(clearFormatData(spreadsheetId, spreadsheetType) as AnyAction);
                }
            };

            window.addEventListener('spreadsheet:tabClosed', handleTabClose as EventListener);
            (window as any).__SPREADSHEET_TAB_CLOSE_LISTENER_ADDED__ = true;
        }
    }

    mountReactNode(
      <Provider store={store}>
        <SpreadsheetDetails {...spreadsheetProps} />
      </Provider>,
      document.getElementById(componentId)!
    );
  } catch (err) {
    console.error(err);
  }
};
